<template>
    <div class="step-component">
        <div class="row">
            <div class="col-xs-12">
                <div class="step-container">
                    <div :class="'arrow-container ' + ((this.step == 'personal' || this.step == 'contact' || this.step == 'upload') ? 'active' : 'inactive')">
                        <div class="inner">
                            <span class="number">1</span>
                            <span class="text hidden-xs hidden-sm">Persönliche Daten</span>
                        </div>
                        <div class="arrow-right"></div>
                    </div>
                    <div :class="'arrow-container ' + ((this.step === 'contact' || this.step === 'upload') ? 'active' : 'inactive')">
                        <div class="inner">
                            <span class="number">2</span>
                            <span class="text hidden-xs hidden-sm">Kommunikationsdaten</span>
                        </div>
                        <div class="arrow-left"></div>
                        <div class="arrow-right"></div>
                    </div>
                    <div :class="'arrow-container ' + ((this.step === 'upload') ? 'active' : 'inactive')">
                        <div class="inner">
                            <span class="number">3</span>
                            <span class="text hidden-xs hidden-sm">Anlagen</span>
                        </div>
                        <div class="arrow-left"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['step'],
}
</script>

<style lang="scss">
.step-component {
    .step-container {
        display: flex;
        margin-bottom: 45px;

        .arrow-container {
            position: relative;
            flex: 1;
            height: 32px;
            margin-right: 8px;

            &:last-child {
                margin-right: 0;
            }

            &.inactive {
                background-color: #e8e8e8;

                .arrow-right {
                    border-color: transparent transparent transparent #e8e8e8;
                }

                .arrow-left {
                    border-color: transparent transparent transparent #f1f1f1;
                }

                .inner {
                    color: #3a3a3a;

                    .text {
                        font-weight: normal;
                        color: #808080;
                    }
                }
            }

            &.active {
                background-color: #00a7af;

                .arrow-right {
                    border-color: transparent transparent transparent #00a7af;
                }

                .arrow-left {
                    border-color: transparent transparent transparent #f1f1f1;
                }

                .inner {
                    color: #fff;
                }
            }

            .inner {
                position: absolute;
                width: 100%;
                text-align: center;
                font-size: 14px;
                line-height: 32px;
                font-weight: bold;

                .number {
                    padding-right: 8px;
                }
            }

            .arrow-right {
                position: absolute;
                right: -10px;
                width: 0;
                height: 0;
                border-style: solid;
                border-width: 16px 0 16px 10px;
                z-index: 10;
            }

            .arrow-left {
                position: absolute;
                left: 0;
                width: 0;
                height: 0;
                border-style: solid;
                border-width: 16px 0 16px 10px;
            }
        }
    }
}
</style>
